import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export const ClientReports = ({ reports }) => {
  const [openMonth, setOpenMonth] = useState(null);

  return (
    <div className="rounded-3xl border border-white/15 bg-[#0F1B31]/80 p-6 sm:p-8" data-testid="portal-reports">
      <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-slate-400 mb-6">Monthly Reports</p>
      {reports.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="portal-reports-empty">
          Your first monthly report will appear here once Owen reviews and sends it.
        </p>
      ) : (
        <div className="space-y-3">
          {reports.map((r) => (
            <div key={r.month} className="rounded-2xl border border-white/10 overflow-hidden" data-testid={`portal-report-${r.month}`}>
              <button
                onClick={() => setOpenMonth(openMonth === r.month ? null : r.month)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-white/[0.03] transition-colors duration-300"
              >
                <span className="font-display font-semibold text-white">{r.month} Report</span>
                {openMonth === r.month ? <ChevronUp className="h-4 w-4 text-slate-500" /> : <ChevronDown className="h-4 w-4 text-slate-500" />}
              </button>
              {openMonth === r.month && (
                <div className="border-t border-white/10 px-5 py-5 space-y-6">
                  {Object.entries(r.sections).map(([key, s]) => {
                    if (!s.items?.length && !s.text) return null;
                    return (
                      <div key={key} data-testid={`portal-report-section-${key}`}>
                        <p className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2">{s.title}</p>
                        {s.items?.length > 0 && (
                          <ul className="space-y-1.5">
                            {s.items.map((it, i) => (
                              <li key={i} className="text-sm text-slate-200 flex gap-2">
                                <span className="text-slate-600 shrink-0">{it.date}</span>
                                <span>{it.what}{it.results ? ` — ${it.results}` : ""}</span>
                              </li>
                            ))}
                          </ul>
                        )}
                        {s.text && <p className="text-sm text-slate-300 leading-relaxed">{s.text}</p>}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
